<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="complexes">
					<app-heading :title="`${market.name} Complexes`">
						<template v-slot:left>
							<app-button
								v-if="$ravello.can('marketmath.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'market-complex', params: { complex: 'new' } }"
							>Add Complex</app-button>
						</template>
						<template v-slot:right>
							<app-button
								button
								small
								outlined
								color="secondary"
								icon="fa-download"
								@click="exportV2Complexes"
							>Export (V2)</app-button>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="complexes"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								:initial-state="tableState"
								search
								sort-by="name"
								@search="onSearch"
								@update="fetchComplexes"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('marketmath.put')"
										color="secondary"
										:to="{ name: 'market-complex', params: { complex: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('marketmath.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove complex`
											+ ` <b>${item.name}</b>?`"
										title="Remove Complex"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'market-complex', params: { complex: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { filters, search, tableState } from '@/mixins'
import { marketMathTabs } from '@/datasources/tabs'
import { exportCollection2 } from '@/utils/import'

export default {
	mixins: [filters, search, tableState],
	data() {
		return {
			market: {
				name: '',
			},
			complexes: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'City',
				value: 'market_city.name',
				sortable: false,
			}, {
				text: 'Area',
				value: 'area.name',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
			defaultTableSort: 'name',
		}
	},
	computed: {
		marketId() {
			return this.$route.params.market
		},
	},
	async mounted() {
		this.market = await this.$ravello.graphql('market', this.marketId)
			.fields(['name'])
			.query()

		this.tabs = marketMathTabs(this.marketId)
	},
	methods: {
		async fetchComplexes(pagination) {
			this.updateTableState(pagination)

			const request = this.$ravello.graphql('complexes')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fields(['_id', 'name', 'slug'])
				.include(this.$ravello.graphql('market_city').field('name'))
				.include(this.$ravello.graphql('area').field('name'))
				.fromPagination(pagination)

			if (this.count === -1 && !this.searchString) {
				request.count('count')
			}

			if (this.searchText) {
				request.search(this.searchText)
			}
			try {
				this.complexes = await request.query()

				if (this.searchText) {
					this.count = this.complexes.length
				}
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('markets')
					.to(this.marketId)
					.to('complexes')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		async exportV2Complexes() {
			const request = this.$ravello.graphql('complexes')
				.parent(this.$ravello.graphql('market', this.marketId))
				.fields(['_id', 'name', 'heading2', 'heading3', 'slug'])
				.include(this.$ravello.graphql('area').field('_id'))

			await exportCollection2('complexes', 'json', request, {
				graphql: true,
				map: entry => ({
					legacyId: entry._id,
					name: entry.name,
					uriName: entry.slug,
					h2: entry.heading2,
					description: entry.heading3,
					legacyArea: entry.area._id,
				}),
			})
		},
	},
}
</script>
